import { render, staticRenderFns } from "./UserVoice.vue?vue&type=template&id=2b614f68&scoped=true"
import script from "./UserVoice.vue?vue&type=script&lang=js"
export * from "./UserVoice.vue?vue&type=script&lang=js"
import style0 from "./UserVoice.vue?vue&type=style&index=0&id=2b614f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b614f68",
  null
  
)

export default component.exports